import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import Button from '../../components/UI/Button/Button';

import classes from './SignUp.module.css';


class VerifyEmail extends Component {

    resendHandler = () => {
        this.props.resendVerificationEmail();
    }

    render() {
        return (
            <div className={classes.Box}>
                <p>Please verify your email</p>
                <Button clicked={this.resendHandler}>Resend Email</Button>
            </div>
        );
    };
};

const mapStateToProps = state => {
    return {

    };
}

const mapDispatchToProps = dispatch => {
    return {
        resendVerificationEmail: () => dispatch(actions.sendEmailVerificationLink())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmail);